import React from "react";
import { Routes as RouterRoutes, Route, Navigate } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import AdminDashboard from './pages/admin-dashboard';
import AdminRoadmap from './pages/admin-roadmap';
import LoginPage from './pages/login';
import CommissionTracking from './pages/commission-tracking';
import PartnerRegistration from './pages/partner-registration';
import PartnerProfile from './pages/partner-profile';
import PartnerDashboard from './pages/partner-dashboard';
import LinkGenerator from './pages/link-generator';
import LinkAnalytics from './pages/link-analytics';
import HelpDocumentation from './pages/help-documentation';
import PrivateMessaging from './pages/private-messaging';
import EnhancedArtistProfile from './pages/enhanced-artist-profile';
import AdvancedSearch from './pages/advanced-search';
import ProfessionalFeed from './pages/professional-feed';
import ConnectionRecommendations from './pages/connection-recommendations';
import PremiumSubscriptionManagement from './pages/premium-subscription-management';
import SecureCommunicationCenter from './pages/secure-communication-center';
import RegistrationType from './pages/registration-type';
import BookingDashboard from './pages/booking-dashboard';
import BookingDetail from './pages/booking-detail';
import PublicArtists from './pages/public-artists';
import PublicArtistDetail from './pages/public-artist-detail';
import ArtistProfileSettings from './pages/artist-profile-settings';

import HomePage from './pages/home';
import MainLayout from './components/ui/MainLayout';
import { useAuth } from './contexts/AuthContext';

// Simple protected route wrapper
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  if (loading) return null; // Could return a spinner
  return isAuthenticated ? children : <Navigate to="/" replace />;
};

const Routes = () => {
  return (
    <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        <Route element={<MainLayout />}>
          <Route path="/" element={<HomePage />} />
          {/* Protected application routes */}
          <Route path="/commission-tracking" element={<ProtectedRoute><CommissionTracking /></ProtectedRoute>} />
          <Route path="/partner-profile" element={<ProtectedRoute><PartnerProfile /></ProtectedRoute>} />
          <Route path="/partner-dashboard" element={<ProtectedRoute><PartnerDashboard /></ProtectedRoute>} />
          <Route path="/link-generator" element={<ProtectedRoute><LinkGenerator /></ProtectedRoute>} />
          <Route path="/link-analytics" element={<ProtectedRoute><LinkAnalytics /></ProtectedRoute>} />
          <Route path="/help-documentation" element={<ProtectedRoute><HelpDocumentation /></ProtectedRoute>} />
          <Route path="/private-messaging" element={<ProtectedRoute><PrivateMessaging /></ProtectedRoute>} />
          <Route path="/enhanced-artist-profile" element={<ProtectedRoute><EnhancedArtistProfile /></ProtectedRoute>} />
          <Route path="/advanced-search" element={<ProtectedRoute><AdvancedSearch /></ProtectedRoute>} />
          <Route path="/professional-feed" element={<ProtectedRoute><ProfessionalFeed /></ProtectedRoute>} />
          <Route path="/connection-recommendations" element={<ProtectedRoute><ConnectionRecommendations /></ProtectedRoute>} />
          <Route path="/premium-subscription-management" element={<ProtectedRoute><PremiumSubscriptionManagement /></ProtectedRoute>} />
          <Route path="/secure-communication-center" element={<ProtectedRoute><SecureCommunicationCenter /></ProtectedRoute>} />
          <Route path="/artists" element={<PublicArtists />} />
          <Route path="/artists/:id" element={<PublicArtistDetail />} />
          <Route path="/booking-dashboard" element={<ProtectedRoute><BookingDashboard /></ProtectedRoute>} />
          <Route path="/artist-settings" element={<ProtectedRoute><ArtistProfileSettings /></ProtectedRoute>} />
          <Route path="/bookings/:id" element={<ProtectedRoute><BookingDetail /></ProtectedRoute>} />
        </Route>
        {/* Routes outside MainLayout */}
        <Route path="/admin-dashboard" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
        <Route path="/admin-roadmap" element={<ProtectedRoute><AdminRoadmap /></ProtectedRoute>} />
        <Route path="/login" element={<LoginPage />} />
  <Route path="/register" element={<RegistrationType />} />
        <Route path="/partner-registration" element={<PartnerRegistration />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
    </ErrorBoundary>
  );
};

export default Routes;